import { useEffect, useState } from 'react';

export const calcProgress = (total: number, newTotalSeconds: number) => {
  if (newTotalSeconds > 0) {
    return (newTotalSeconds / total) * 100;
  }
  return 0;
};

export const useProgress = ({
  total,
  callback,
}: {
  total: number;
  callback: () => number;
}) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    setProgress(calcProgress(total, callback()));
  }, [callback, total]);

  return [progress] as const;
};
